// Copyright (c) 2022 by Move Closer

import { ModuleBase, ModuleFactory } from '../../contexts'

import { abstractModuleFactory, getDefaultModuleAlignment } from '../abstract/form'

import { AvailableModuleDriver } from '../allowed'
import { ImageModule, ImageModuleContent } from './Image.contracts'

/**
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const imageContentFactory = (): ImageModuleContent => ({ image: null, icon: undefined, link: undefined })

/**
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
export const imageFactory: ModuleFactory<ImageModule> = {
  ...abstractModuleFactory,
  createModule (): ModuleBase<ImageModule> {
    return {
      alignment: getDefaultModuleAlignment(),
      content: imageContentFactory(),
      driver: AvailableModuleDriver.Image
    }
  }
}
